export default "__VITE_ASSET__BkV3veal__"